export default Object.freeze({
  Unknown: 0,
  Online: 1,
  Offline: 2,
  Disabled: 3,
});
